export const AUTH_BASE = '/auth';

export const AUTH_ENDPOINTS = {
  login: `${AUTH_BASE}/login`,
  logout: `${AUTH_BASE}/logout`,
  logoutAll: `${AUTH_BASE}/logout-all`,
  refresh: `${AUTH_BASE}/refresh`,
  me: `${AUTH_BASE}/me`,
  forgotPassword: `${AUTH_BASE}/forgot-password`,
  verifyOtp: `${AUTH_BASE}/verify-otp`,
  resetPassword: `${AUTH_BASE}/reset-password`,
  updatePassword: `${AUTH_BASE}/update-password`,
  sessions: `${AUTH_BASE}/sessions`,
  sessionById: (sessionId) => `${AUTH_BASE}/sessions/${sessionId}`,
};
